import { useEffect, useState } from 'react';
import { QuestionSetClient, QuestionSetItemTypeClient } from '../services/apiClient'; 
import { API_BASE_URL } from '../config/config';
import axiosInstance from "../services/axiosInstance";

const useQuestionSetItemTypes = () => {
    const [questionSetItemTypes, setQuestionSetItemTypes] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const client = new QuestionSetItemTypeClient(API_BASE_URL, axiosInstance);

    useEffect(() => {
        const fetchTypes = async () => {
            setIsLoading(true);
            try {
                const types = await client.getQuestionSetItemTypes();
                if (types && types.success && types.data) {
                    setQuestionSetItemTypes(types.data);
                } else {
                    setError('Failed to fetch question sets');
                }
            } catch (err) {
                setError('Error fetching question sets');
                console.error('Error fetching question sets:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTypes();
    }, []);

    return { questionSetItemTypes, isLoading, error };
};

export default useQuestionSetItemTypes;
